import querystring from 'querystring'
import { mapState, mapGetters, mapMutations } from 'vuex'

import Stage from './stage'
import Tutorial from './tutorial'
import StageSelector from './stage-selector'
import { storage } from '@shared/utils/storage'
import { PreLoadable } from '@shared/services/preloader'
import { userStorage } from '@shared/store/modules/user'


const DAY = 24 * 60 * 60 * 1000
const CHECK_STARTED = new Date() > new Date('2018-03-30')
const VISITS_KEY = 'user_visit_dates';

(function () {
  let past

  try {
    past = JSON.parse(localStorage.getItem(VISITS_KEY)).map(x => parseInt(x))
  } catch(e) {
    past = []
  }

  let today = new Date().getOnlyDate().valueOf()

  if (past.has(today)) {
    return
  }

  past.push(today)

  if (past.length > 10) {
    past.shift()
  }

  localStorage.setItem(VISITS_KEY, JSON.stringify(past))
})()


export default {
  template: '#calendar',
  mixins: [PreLoadable],
  inject: ['stagesService', 'productsService'],

  props: {
    gif: { type: String }
  },

  data() { return {
    stage: {},
    showTutorial: false
  } },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAuthenticated']),
  },

  components: {
    Stage,
    StageSelector,
    Tutorial
  },

  watch: {
    isAuthenticated(nval, oval) {
      if (nval === true && oval === false) {
        this.$nextTick(x => this.setCurrentStage())
      }
    }
  },

  created() {
    this.stagesService.$on('updateStagesItem', ({ id, data }) => {
      if (this.stage.order == id) {
        this.stageReady(data)
      }
    })

    this.productsService.$on('frequentAllergy', x => {
      this.$refs.frequentAllergy.open()
    })
  },
  methods: {
    ...mapMutations('user', {
      'setSession': 'SET',
    }),

    stageReady(stage) {
      let shown = storage.getItem('tutorial-have-already-shown')
      if (!shown && !this.user.tutorial_seen) {
        storage.setItem('tutorial-have-already-shown', true)

        let today = new Date()
        today.setHours(0,0,0,0)
        let isToday = !stage.days_periods.find(x => new Date(x.date) < today)
        if (isToday) {
          this.showTutorial = true
        }
      }

      this.stage = stage

      this.$nextTick(x => this.$refs.stage.stage = stage)
    },
    switchTutorial() {
      this.showTutorial = !this.showTutorial
    },
    setCurrentStage() {
      this.setLoading()
      if (this.$refs.loader) {
        this.$refs.loader.open()
      }
      // if (saved != null && this.isAuthenticated) {
      //   this.stagesService.initializeStage(
      //     { stage: saved.stage, stages: saved.ate }
      //   )
      //     .then(stage => {
      //       this.unsetLoading()
      //       this.stageReady(stage)
      //     })
      //   return
      // }

      this.stagesService.getCurrent().then(({stages, current}) => {
        if (typeof current === 'undefined') {
          this.unsetLoading()
          if (this.$refs.loader) {
            this.$refs.loader.close()
          }
          if (stages.every(x => x.status == 'past')) {
            this.finish()
          } else if (stages.some(x => x.status == 'past')) {
            if (CHECK_STARTED) {
              let last = Date.getMax(
                stages.filter(x => x.status == 'past')
                  .map(x => x.end_date)
                  .map(x => new Date(x))
              )
              let past
              try {
                past = JSON.parse(localStorage.getItem(VISITS_KEY)).map(x => parseInt(x))
                let today = new Date().getOnlyDate().valueOf()
                let index = past.indexOf(today)
                if (index != -1) {
                  past.splice(index, 1)
                }

                if (past.length > 0) {
                  past = Math.max.apply(Math, past)

                  if (past.valueOf() + DAY < today && last.valueOf() + DAY < today) {
                    this.$refs.nextOutdated.open()
                  }
                }
              } catch(e) {
                console.error(e)
                past = []
              }
            }

            this.$refs.selector
              .choose({
                ate: [],
                select: stages.find(x => x.status == 'empty').order
              })
          } else {
            // let query = querystring.parse(window.location.search.substr(1))

            // if (typeof query.select === 'undefined') {
            //   this.$refs.selector.test()
            // }
          }
        } else {
          this.stagesService.getStage(current.order).then(stage => {
            this.stageReady(stage)
            this.unsetLoading()
            if (this.$refs.loader) {
              this.$refs.loader.close()
            }
          })
        }
      })
    },

    finish() {
      
      this.$refs.finish.open()
    },

    test() {
      this.$refs.finish.close()
      this.$refs.selector.test()
    },

    auth() {
      this.$refs.selector.$refs.auth.start()
        .then(user => this.setSession(user))
    },
    select() {
      this.$refs.selector.$refs.selector.start()
        .then(stage => {
          this.stagesService.getStages().then(stages => {
            let ate = stages.filter(x => x.order < stage)

            if (stage > this.stage.order) {
              ate = ate.filter(x => x.status == 'empty')
            }

            this.$refs.selector
              .choose({
                ate: ate.map(x => x.order),
                select: stage
              }, true, stage > this.stage.order)
          })
        })
    },

    newStage() {
      this.stagesService.getStages().then(stages => {
        this.$refs.selector
          .choose({
            ate: [],
            select: stages.find(x => x.status == 'empty' && x.order > this.stage.order).order
          })
      })
    },

    switchStage(order) {
      this.stagesService.getStage(order)
        .then(stage => {
          this.stageReady(stage)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/calendar.js